import { render, staticRenderFns } from "./reviews-popup.vue?vue&type=template&id=d016c96e"
import script from "./reviews-popup.vue?vue&type=script&lang=js"
export * from "./reviews-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports